import * as yup from "yup";
import { StringHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { StateDto } from "../../../services/dto";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

interface StateFormProps {
  data?: StateDto;
  loading?: boolean;
  show: boolean;
  onHide: () => void;
  onSave: (values: any) => DrawerFormSaveResult;
  regionLookup: DropdownOption[] | undefined;
}

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  description: yup.string().required("Description is required"),
  abbreviation: yup.string().required("Abbreviation is required"),
  capital: yup.string().required("Capital is required"),
  regionId: yup.string().required("Region is required."),
  sortValue: yup.number().required("Sort Value is required."),
});
export const StateForm = (props: StateFormProps) => {
  const title: string =
    StringHelper.whenNullOrEmpty(props.data?.id, Constants.emptyGuid) ===
    Constants.emptyGuid
      ? "New State"
      : "Edit State";

  const onSubmit = (data: StateDto) => {
    return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
  };

  return (
    <Drawer.Form
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props.onHide}
      title={title}
      initialValues={props.data ?? { sortValue: 100 }}
      validationSchema={validationSchema}
      on_Submit={onSubmit}
      enableReinitialize
    >
      <Form.Text name="name" label="Name" isLoading={props.loading} />
      <Form.TextArea
        name="description"
        rows={3}
        label="Description"
        isLoading={props.loading}
      />
      <Form.Text
        name="abbreviation"
        placeholder="Enter text"
        label="Abbreviation"
        isLoading={props.loading}
      />
      <Form.Text
        name="capital"
        placeholder="Enter text"
        label="Capital"
        isLoading={props.loading}
      />
      <Form.Dropdown
        name="regionId"
        label="Region"
        isLoading={props.loading}
        blankOption={{
          key: Constants.emptyGuid,
          display: "Select Region",
          value: Constants.emptyString,
        }}
        options={props.regionLookup}
      />
      <Form.Number
        name="sortValue"
        label="Sort Value"
        isLoading={props.loading}
      />
    </Drawer.Form>
  );
};
